/* IE has a bug where an element underneath a positioned element can be activated
 when clicking the above element. One of the buttons in the UI happens to be above
 a dropdown which can easily be activated. */
export default {
    dependencies: ['$element'],
    callable(ele) {
        ele.addEventListener('click', event => {
            if (event.target === ele) {
                event.stopPropagation();
            }
        });
    },
};



// WEBPACK FOOTER //
// ./controllers/ieWorkaround.js